import { render } from "./AddNewMsisdnPriceEditor.vue?vue&type=template&id=4a87d4a4"
import script from "./AddNewMsisdnPriceEditor.vue?vue&type=script&lang=js"
export * from "./AddNewMsisdnPriceEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__